export const notFoundPageTranslationsEn = {
    notFoundPageNotFound: 'Strona nie znaleziona',
    notFoundPageBackToInitialLocation: 'Wróć do strony głównej',
};

export const notFoundPageTranslationsPl = {
    notFoundPageNotFound: 'Strona nie znaleziona',
    notFoundPageBackToInitialLocation: 'Wróć do strony głównej',
};
